export const isAbsolute = (url: string) => !!/^((https?:)?\/\/|mailto:|tel:)/.exec(url);
